export default class InitializeForm {
    initialize() {
        this.collapseSection();
        this.mobileFilters();
        // this.dashboardMenu();
    }

    // General collapse/show section
    collapseSection() {
        $('body').on('click tap', '.collapse-section-action', function(e) {
            e.preventDefault();

            var section_toggle = $(this).find('.collapse-section-toggle');
            var section_id = section_toggle.attr('data-section-id');

            section_toggle.toggleClass('closed');
            $(`#${section_id}`).slideToggle();
        });
    }
    
    // Collapse mobile filters
    mobileFilters() {
        var mobile_filters = $('.mobile-filter-options');
        var mobile_filters_header = $('.mobile-filter-options .top-header-bar');

        // Open button
        $('.mobile-toggle-filters').on('click tap', function(e) {
            e.preventDefault();

            // Open the filters dropdown
            mobile_filters.animate({top: '0'}, '1.5s');
            mobile_filters_header.animate({top: '0'}, '1.5s');

            // Let Livewire know to keep it open
            Livewire.emit('toggleDropdown', 'open');
        });

        // Close button
        $('.close-mobile-menu').on('click tap', function(e) {
            e.preventDefault();

            // Open the filters dropdown
            mobile_filters.animate({top: '-100vh'}, '1.5s');
            mobile_filters_header.animate({top: '-100vh'}, '1.5s');

            // Let Livewire know to close it
            Livewire.emit('toggleDropdown', 'close');

            $('body').css({
                overflow: 'auto',
                height: 'auto'
            });
        });
    }

    // Collapse the dashboard menu
    // dashboardMenu() {
    //     var menu_toggle     = $('.mobile-dashboard-toggle');
    //     var menu_options    = $('.nav-options');

    //     if (menu_toggle) {
    //         menu_toggle.on('click tap', function(e) {
    //             menu_toggle.toggleClass('open');
    //             menu_options.slideToggle();
    //         });
    
    //         // Close on click outside
    //         $(document).on("click", function(event){
    //             var $trigger = $(".dashboard-navigation-container");
    
    //             if($trigger !== event.target && !$trigger.has(event.target).length){
    //                 menu_toggle.removeClass('open');
    //                 menu_options.slideUp();
    //             }            
    //         });
    //     }
    // }
} 